import React from "react";
import { Container } from "react-bootstrap";
import "../../styles/components/slices/video.scss";

import wave from "../../../static/images/general/footer-wave.png";

const Video = ({ slice }) => {
  if (!slice) return null;

  let classes = "null";
  const showDesktop = slice.primary.show_on_desktop;
  const showMobile = slice.primary.show_on_mobile;

  const isDesktopVisible = showDesktop === true;
  const isMobileVisible = showMobile === true;

  // Show video section in mobile and/or desktop
  if (isDesktopVisible && !isMobileVisible) {
    classes = "d-none d-lg-block";
  } else if (!isDesktopVisible && isMobileVisible) {
    classes = "d-block d-lg-none";
  } else if (!isDesktopVisible && !isMobileVisible) {
    classes = "d-none";
  } else if (isDesktopVisible && isMobileVisible) {
    classes = "d-block";
  }

  return (
    <Container fluid className={`video-container p-0 ${classes}`}>
      <div className="video-container ratio ratio-16x9">
        <iframe
          title="YouTube video player"
          className="video-iframe"
          src="https://www.youtube.com/embed/ApuuSL0hZ30?autoplay=1&loop=1&controls=0&disablekb=1&fs=0&playsinline=1&vq=hd1080&modestbranding=1&mute=1&playlist=ApuuSL0hZ30"
        />
        <div className="no-interaction-overlay" />
      </div>

      <div className="footer-wave d-none">
        <img src={wave} alt="wave" />
      </div>
    </Container>
  );
};

export default Video;
